import { makeStyles } from "@material-ui/core/styles"
import { colorGreen, colorRed } from "../../colors"

const useStyles = makeStyles((theme) => ({
	content: {
		width: "100%",
		padding: "100px !important",
		height: "fit-content",
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
		border: "solid thin deeppink",
	},
	scannerContent: {
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
		padding: "0px !important",
		overflow: "hidden !important",
	},
	scannerModalContainer: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},
	scannerModalHeader: {
		width: "100%",
		minHeight: "30px",
		padding: "2px 10px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		borderBottom: "solid thin silver",
	},
	scannerModalHeaderChild: {
		flex: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		minHeight: "30px",
		padding: "5px 10px",
		fontSize: "14px",
	},
	scannerModalHeaderCenter: {
		flex: 3,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: "5px",
	},
	messageContainer: {
		display: "flex",
		alignItems: "center",
		fontSize: "0.8rem",
		fontWeight: "bold",
	},
	scannerModalHeaderBackBtn: {
		cursor: "pointer",
	},
	nodeLocationNavContainer: {
		height: "80px",
	},
	actions: {
		justifyContent: "space-between",
	},
	actionButton: {
		margin: "5px",
		flex: 1,
	},
	textInputBox: {
		margin: "15px 0 0 0",
		padding: "4px",
		width: "90%",
	},
	fabClose: {
		position: "fixed",
		bottom: 0,
		right: 0,
		margin: theme.spacing(2),
		zIndex: 500,
	},
	fabText: {
		position: "fixed",
		bottom: 0,
		right: 40 + 24,
		margin: theme.spacing(2),
		zIndex: 500,
	},
	componentSelectionMenuContainer: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
	},
	componentSelectionList: {
		listStyle: "none",
		padding: 0,
		textAlign: "center",
		fontWeight: "bold",
	},
	componentSelectionListItem: {
		margin: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	componentEnabled: {
		cursor: "pointer",
		display: "flex",
		alignItems: "center",
	},
	scannerParentContainer: {
		overflow: "hidden",
	},
	componentOptionButton: {
		width: "200px",
		margin: "5px",
	},
	barCodeButton: {
		transform: "rotate(90deg)",
	},
	rememberSelectionBtn: {
		margin: "5px",
	},
	componentScannedStatusIcon: {
		width: "30px",
		height: "30px",
		padding: "5px",
		border: "solid thin silver",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	icon: {
		height: "20px",
		width: "20px",
	},
	warningMessageSuccess: {
		color: colorGreen,
	},
	warningMessageError: {
		color: colorRed,
	},
}))

export default useStyles
